<template>
  <div class="specimen_collection">
    <van-nav-bar title="样本采集" v-if="isWx==1" left-arrow @click-left="onClickLeft" fixed></van-nav-bar>
    <van-nav-bar title="样本采集" v-else fixed></van-nav-bar>
    <div class="navheight"></div>
    <div class="swine_wrap">
        <van-collapse v-model="activeNames">
            <van-collapse-item :title="index + 1 + '、' +item.title" :name="index" v-for="(item,index) in contentList" :key="index">
                <p>{{item.textItem}}</p>
                <div style="padding-top:10px;">
                    <p v-for="(ele,i) in item.list" :key="i" style="line-height:22px;">
                      <span style="font-weight: 600;display:block;">{{ele.title}}：</span>
                      <span style="color:#4C4C4C;">{{ele.textItem}}</span>
                    </p>
                </div>
            </van-collapse-item>
        </van-collapse>
    </div>
    <Top :btnFlag="btnFlag"/>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import Top from '@/components/top.vue'
export default {
  components: {
    Top
  },
  name: 'specimencollection',
  data(){
    return{
      btnFlag:false,
      activeNames:[0],
      contentList:[
        {
          title:'猪尿液的采集',
          textItem:'在畜产品的监管过程中，特别是瘦肉精及其他违禁药品的检测中，猪尿样的真实有效采集非常重要。在动物排尿时，用洁净的纸杯或一次性口杯直接接取，也可使用塑料袋，固定在雌畜外阴部或雄畜的阴茎下接取尿液。采取尿液，宜早晨进行。装尿液的杯、塑料袋和瓶子要干净， 1头猪1套器具。',
        },
        {
          title:'猪粪便的采集',
          textItem:'应选新鲜粪便至少10g，做寄生虫检查的粪便应装入容器，在24h内送达实验室。如运输时间超过24h则应进行冷冻，以防寄生虫虫卵孵化。运送粪便样品可用带螺帽容器或灭菌塑料袋，不得使用带皮塞的试管。',
        },
        {
          title:'肛拭子样品',
          textItem:'采集肛拭子样品时，取无菌棉拭子插入猪肛门中，旋转2-3圈，刮取直肠黏液或粪便，放入装有30%甘油磷酸盐缓冲液或半固体培养基中送检。粪便样品通常在4℃ 下保存和运输。',
        },
        {
          title:'生殖道分泌物',
          list:[
            {title:'(1) 采集阴道或包皮冲洗液',textItem:'将消毒好的特制吸管插入子宫颈口或阴道内，向内注射少量营养液或生理盐水，用吸球反复抽吸几次后吸出液体，注入培养液中。用软胶管插入公畜的包皮内，向内注射少量的营养液或生理盐水。多次揉搓，使液体充分冲洗包皮内壁。收集冲洗液注入无菌容器中。'},
            {title:'(2) 生殖道拭子样品',textItem:'采用合适的拭子采取阴道或包皮内分泌物，有时也可采集宫颈或尿道拭子。'}
          ],
          textItem:'通过除去或抑制血液中某些凝血因子的活性来阻止血液凝固。实际应用中要根据不同的需要进行抗凝剂的选择，常用的抗凝剂有肝素、乙二胶四乙酸盐(EDTA盐)、枸橼酸钠、草酸盐等4种。',
        },
        {
          title:'精液样品',
          textItem:'精液样品最好用假阴道挤压阴茎或人工刺激的方法采集。精液样品精子含量要多，不要加入防腐剂，且应避免抗菌冲洗液污染。',
        },
        {
          title:'猪结膜拭子的采集',
          textItem:'眼结膜表面用拭子轻轻擦拭后，置于灭菌的30%甘油磷酸盐缓冲液（病毒检测加双抗）或运输培养基中送检。',
        },
        {
          title:'猪鼻腔拭子的采集',
          textItem:'取无菌棉签，插入猪鼻腔2-3cm，轻轻擦拭并慢慢旋转2-3圈，沾取鼻腔分泌物后，立即将拭子浸入保存液或半固体培养基中，剪下或折断，盖上管盖，密封低温保存。',
        },
        {
          title:'猪唾液的采集',
          textItem:'将样品采集袋固定在猪只可以接触到的位置，悬挂30min，有效咀嚼时间不低于3min。取下样品采集袋放入样品收集袋，把唾液挤出，在收集袋下角剪开一个小口，将里面的唾液转移到准备好的样品收集管内。每个样品收集管都要标明取样猪场、取样栏舍、取样日期。',
        },
        {
          title:'皮肤样品采集',
          textItem:'无菌采取2g感染的上皮组织或水泡皮置于5ml 30%甘油磷酸盐缓冲液中送检。',
        },
        {
          title:'毛发或绒毛样品',
          textItem:'拔取毛发或绒毛样品，可用于检查体表的螨虫、跳蚤和真菌感染。用解剖刀片边缘刮取的表层皮屑用于检查皮肤真菌，深层皮屑（刮至轻微出血）可用于检查疥螨。',
        },
        {
          title:'水疱液、水肿液的采集',
          textItem:'水泡液应取自未破裂的水泡。可用灭菌注射器或其他器具吸取水泡液，置于灭菌容器中送检。',
        },
        {
          title:'猪脓汁、粘液或关节液',
          textItem:'采用烫烙法消毒采样部位，用灭菌吸管、毛细吸管或注射器经烫烙部位插入，吸取内部液体病料，然后将病料注入灭菌的试管中，塞好棉塞送检。也可用接种环经消毒的部位插入，提取病料直接接种在培养基上。',
        },
        {
          title:'猪组织病料的采集（心肝脾肺肾，淋巴结，扁桃体）',
          list:[
            {title:'(1) 做病原核酸检测',textItem:'用无菌手术刀或剪刀切取采集心、肝、脾、肺、肾上的病变与正常组织交接处的组织及整个淋巴结或扁桃体，组织大小一般为2cmx3cm，每个组织块应单独放在已消毒的容器或采样袋内，标记动物、组织名称和采样日期。'},
            {title:'(2) 样本用于做细菌、病毒、寄生虫分离或药敏试验',textItem:'选取发病早期未经抗生素治疗的动物。可用一套新消毒的器械切取所需器官的组织块，每个组织块应单独放在已消毒的容器内，样品不可冷冻。切取完整的半边肺脏，其余组织的大小和做病原检测时相同。'}
          ],
          textItem:'采集病料要及时，应在病死前或病死后立即进行，最好不要超过6h。用常规解剖器械剥离样本动物的皮肤，体腔用消毒的器械剥开，剖开腹腔时，注意不要损坏肠道。无菌操作，防止取样过程中病料的污染。',
        },
        {
          title:'活猪扁桃体的采集',
          textItem:'用合适大小的开口器打开猪口腔并压住猪舌，将采样枪的采样钩紧靠扁桃体，注意不要搅动，以免创口过大。扣动扳机取出扁桃体组织。拿出采样枪，将切取的组织块从刀槽中挑至灭菌离心管中，做好标记。',
        },
        {
          title:'猪流产胎儿的采集',
          textItem:'选取无腐败的胚胎、胎儿或胎儿的实质器官，装入适宜容器内立即送检。如果在24h内不能将样品送达实验室，应冷冻运送。',
        },
        {
          title:'猪场环境样品的采集',
          textItem:'环境样品通常采集垃圾、垫草或排泄的粪便或尿液。可用拭子灭菌的湿毛巾在通风道、饲料槽和下水处采样。这种采样在有特殊设备的人工授精中心和屠宰场尤其重要。样品也可在食槽或大容器的动物饲料中采集。水样样品可从饲槽、饮水器、水箱或天然及人工供应水源中采集。',
        },
        {
          title:'车辆样品采集',
          textItem:'猪场车辆，尤其是运输猪只和粪便的车辆，是很多病原的重要传播载体。在车辆的前后车轮里侧，车厢4个内角，前脸、后门、车顶、底板、刹车板，将灭菌毛巾用无菌生理盐水沾湿，擦以上采样点，然后将毛巾上的水挤至样品袋或样品管中。',
        },
      ],
      browser: {
        trident: navigator.userAgent.indexOf('Trident') > -1, //IE内核
        presto: navigator.userAgent.indexOf('Presto') > -1, //opera内核
        webKit: navigator.userAgent.indexOf('AppleWebKit') > -1, //苹果、谷歌内核
        gecko: navigator.userAgent.indexOf('Gecko') > -1 && navigator.userAgent.indexOf('KHTML') == -1, //火狐内核
        mobile: !!navigator.userAgent.match(/AppleWebKit.*Mobile.*/) || !!navigator.userAgent.match(/AppleWebKit/), //是否为移动终端
        ios: !!navigator.userAgent.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/), //ios终端
        android: navigator.userAgent.indexOf('Android') > -1 || navigator.userAgent.indexOf('Linux') > -1, //android终端或者uc浏览器
        iPhone: navigator.userAgent.indexOf('iPhone') > -1 || navigator.userAgent.indexOf('Mac') > -1, //是否为iPhone或者QQHD浏览器
        iPad: navigator.userAgent.indexOf('iPad') > -1, //是否iPad
        webApp: navigator.userAgent.indexOf('Safari') == -1 //是否web应该程序，没有头部与底部
      },
      isWx:1,
    }
  },
  
  created(){
    const ua = window.navigator.userAgent.toLowerCase();
    if(ua.indexOf('micromessenger') == -1) {
      this.isWx = 1
    }else{
      this.isWx = 2
    }
  },
  methods: {
    onClickLeft() {
      this.$router.back(-1)
    }
  }
}
</script>

<style lang="scss">
.specimen_collection{
    text-align: left !important;
    .van-nav-bar .van-icon{
        color: #999999;
    }
    .van-cell{
      color:#4C4C4C !important;
      font-size:16px !important;
      font-weight: 600 !important;
    }
    .van-collapse-item__content{
      color:#4C4C4C !important;
      font-size:14px !important;
      background:rgba(245,245,245,1) !important;
    }
    .content{
        padding: 15px 14px 10px;
        font-family:PingFangSC-Regular;
        line-height:24px;
        color:rgba(32,32,32,1);
        opacity:1;
    }
}
.van-button--normal {
  width: 40%;
  margin: 10px;
}
.navheight {
  height: 46px;
}
</style>
